import {Component, ChangeDetectorRef, ContentChild, ElementRef, ChangeDetectionStrategy} from '@angular/core';
import { TranslateService} from "@ngx-translate/core";
import {ThemeService} from '@services/theme.service';
import {SummaryWrapperBase} from '@app/wrappers/summary-wrapper-base';
import {IMenuItem} from '@models/i-menu-item';
import {AuthService} from '@services/auth.service';

@Component({
  selector: 'msfa-summary-wrapper',
  templateUrl: './msfa-summary-wrapper.html',
  styleUrl: './msfa-summary-wrapper.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MsfaSummaryWrapper extends SummaryWrapperBase {

  @ContentChild('title', { read: ElementRef })  titleEl?: ElementRef ;
  @ContentChild('left', { read: ElementRef })   leftEl?: ElementRef;
  @ContentChild('right', { read: ElementRef })   rightEl?: ElementRef;

  constructor(
    private themeService: ThemeService,
    protected override cdr: ChangeDetectorRef,
    protected override translate: TranslateService,
    protected override authService: AuthService,
  ) {
    super(cdr, translate,authService);
  }

  getCardStyle(item: IMenuItem): Partial<CSSStyleDeclaration> {
    const isDarkTheme = this.themeService.isDarkMode();
    if (isDarkTheme && item.cardStyle?.background) {
      const updatedStyle = {...item.cardStyle};
      //@ts-ignore
      updatedStyle.background = updatedStyle.background.replace(/rgba\(([^,]+),([^,]+),([^,]+),[^)]+\)/, 'rgba($1,$2,$3,0.7)');
      return updatedStyle;
    }
    return item.cardStyle || {};
  }

    get hasTitle() {
      return this.titleEl;
    }

    get hasLeft() {
      return this.leftEl;
    }

    get hasRight() {
      return this.rightEl;
    }
}
